import { EventModelPosition } from '../constants';
import { EventModelDetails } from '../types';

export const formatModelDetails = (model: EventModelDetails) => {
  return model.sizes.map((item) => ({
    sizeId: item.size.id,
    modelId: model.model.id,
    position:
      model.sides.includes(EventModelPosition.Front) &&
      model.sides.includes(EventModelPosition.Back)
        ? EventModelPosition.Both
        : model.sides[0],
    quantity: item.quantity.toString(),
  }));
};
